import { PromiseCompletion } from '@app/Classes/PromiseCompletion';

class LoaderStore {
    public globalLoader: PromiseCompletion = new PromiseCompletion();
}

export const loaderStore = new LoaderStore();